export const READ_CUSTOMER_PRODUCTS_V2_FUNCTION = 'readCustomerProductsV2';
export const READ_CUSTOMER_PRODUCTS_V2_ONE_DATA_FUNCTION =
  'ReadCustomerProducts.v2';
export const READ_BUSINESS_CHECKING_APPLICATION_V1_FUNCTION =
  'readBusinessCheckingApplicationV1';
export const READ_BUSINESS_CHECKING_APPLICATION =
  'ReadBusinessCheckingApplication.v1';
export const READ_TWO_FACTOR_AUTHENTICATION_FOR_USER_V1 =
  'readUserMultiFactorAuthenticationV1';
export const IOS_APP_ID = '681998448';
export const ANDROID_APP_ID = 'com.kabbage.mobile';

export const BCA_BASE_ROUTE = '/en-us/banking/business/checking';
export const BSA_BASE_ROUTE = '/en-us/banking/business/savings';
export const DEPOSITS_BASE_ROUTE = '/en-us/banking/business/deposits';

// routes
export const BCA_ROUTES = {
  ERROR: `${BCA_BASE_ROUTE}/error`,
  HOME: `${BCA_BASE_ROUTE}/home`,
  ACCOUNTS: `${BCA_BASE_ROUTE}/accounts`,
  BSA_ACCOUNTS: `${BSA_BASE_ROUTE}/accounts`,
  ACCOUNTS_DETAILS: `${BCA_BASE_ROUTE}/accounts/:id`,
  BSA_ACCOUNTS_DETAILS: `${BSA_BASE_ROUTE}/accounts/:id`,
  ACCOUNT_MANAGEMENT: `${BCA_BASE_ROUTE}/accounts/manage`,
  MANAGE_PROFILE: `${BCA_BASE_ROUTE}/accounts/manage/profile`,
  DOCUMENT_UPLOAD: `${BCA_BASE_ROUTE}/document-upload`,
  OPEN_NEW_ACCOUNT: `${BCA_BASE_ROUTE}/accounts/open-new-account`,
  AMEX_HOME_PAGE: 'https://www.americanexpress.com',
  BLUEPRINT_APPLY:
    'https://www.americanexpress.com/en-us/business/blueprint/account/create-account?eep=79073&next=onboarding%2Fbusiness-checking&product=business-checking',
  ACCOUNT_REGISTRATION: `${BCA_BASE_ROUTE}/registration?rsvpCode=:rsvpCode`,
  ADDITIONAL_USER_ONBOARDING: `${BCA_BASE_ROUTE}/onboarding/additional-user?rsvpCode=:rsvpCode`,
};

export const BSA_ROUTES = {
  HOME: `${BSA_BASE_ROUTE}/home`,
  ACCOUNTS: `${BSA_BASE_ROUTE}/accounts`,
  ACCOUNTS_DETAILS: `${BSA_BASE_ROUTE}/accounts/:id`,
  ACCOUNT_MANAGEMENT: `${BSA_BASE_ROUTE}/accounts/manage`,
  MANAGE_PROFILE: `${BSA_BASE_ROUTE}/accounts/manage/profile`,
  ERROR: `${BSA_BASE_ROUTE}/error`,
};

export const DEPOSIT_ROUTES = {
  MANAGE_PROFILE: '/en-us/banking/business/deposits/accounts/manage/profile',
};

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

// feature flags
export const BCA_OUTAGE_FF = 'BCA_OUTAGE_ERROR_FF';

// Application Response Types
export const APPLICATION_KIND = {
  ONBOARDING: 'ONBOARDING',
  ADDITIONAL_ACCOUNT: 'ADDITIONAL_ACCOUNT',
  ADD_BENEFICIAL_OWNER: 'ADD_BENEFICIAL_OWNER',
  ADD_STAKEHOLDER: 'ADD_STAKEHOLDER',
  EDIT_BENEFICIAL_OWNER: 'EDIT_BENEFICIAL_OWNER',
  EDIT_STAKEHOLDER: 'EDIT_STAKEHOLDER',
  DELETE_BENEFICIAL_OWNER: 'DELETE_BENEFICIAL_OWNER',
  DELETE_STAKEHOLDER: 'DELETE_STAKEHOLDER',
  UPDATE_BUSINESS_PROFILE: 'UPDATE_BUSINESS_PROFILE',
  UPDATE_INDIVIDUAL_PROFILE: 'UPDATE_INDIVIDUAL_PROFILE',
};

export const APPLICATION_TYPE = {
  BUSINESS_CHECKING: 'BUSINESS_CHECKING',
  CONSUMER_CHECKING: 'CONSUMER_CHECKING',
  CONSUMER_SAVINGS: 'CONSUMER_SAVINGS',
  PERSONAL_SAVINGS: 'PERSONAL_SAVINGS',
};

// application statuses
export const APPLICATION_STATUSES = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  RECOVERABLE_FAILURE: 'RECOVERABLE_FAILURE',
  ACCOUNT_READY: 'ACCOUNT_READY',
  PENDING: 'PENDING',
  DENIED: 'DENIED',
  APPROVED: 'APPROVED',
  REGO_DENIED: 'REGO_DENIED',
  CANCELLED: 'CANCELLED',
};

export const IN_PROGRESS_APPLICATION_STATUSES = [
  APPLICATION_STATUSES.IN_PROGRESS,
  APPLICATION_STATUSES.PENDING,
  APPLICATION_STATUSES.APPROVED,
  APPLICATION_STATUSES.ACCOUNT_READY,
  APPLICATION_STATUSES.NOT_STARTED,
];

export const ROLES = {
  ADMIN: 'ADMIN',
  VIEW_ONLY: 'VIEW_ONLY_USER',
};

export const APPLICATION_EXPECTED_RESPONSE_CODES = [200, 404];

// TODO get from ducks when added to registry
export const BUSINESS_SAVINGS_ACCOUNT = 'AEXP_BUSINESS_SAVINGS_ACCOUNT';
export const BUSINESS_CHECKING_ACCOUNT = 'AEXP_BUSINESS_CHECKING_ACCOUNT';

export const LINE_OF_BUSINESS = {
  BUSINESS_CHECKING: 'businesses_checking',
  BUSINESS_SAVINGS: 'business_savings',
};

export const ACCOUNT_TYPE_PRODUCT_ROUTE_PARAM = {
  [BUSINESS_CHECKING_ACCOUNT]: 'checking',
  [BUSINESS_SAVINGS_ACCOUNT]: 'savings',
};
